import type AppConfig from 'aem-libs-react-ts/src/types/app-config'
import { queryUtils } from 'aem-libs-react-ts/src/utils/queryUtils'

import { HttpClient } from '../../../utility/HttpClient'
import type {
  CalculateChildrenSavingsRequest,
  CalculateChildrenSavingsResponse,
  CalculateTermDepositRequest,
  CalculateTermDepositResponse,
  TermDepositRatesResponse
} from './types'

export const rfaDepositService = ({ webApi }: AppConfig) => {
  const apiBase = 'v1/rfa-depositcalc'
  const httpClient = new HttpClient(webApi, apiBase)

  return {
    calculateTermDeposit: (request: CalculateTermDepositRequest) => {
      const queryPathParams = queryUtils.createQueryStringFromObject(request, '?')
      return httpClient.get<CalculateTermDepositResponse>(`/term-deposit/calculate${queryPathParams}`)
    },

    getRates: () => httpClient.get<TermDepositRatesResponse>('/term-deposit/rates'),

    calculateChildrenSavings: (request: CalculateChildrenSavingsRequest) =>
      httpClient.get<CalculateChildrenSavingsResponse>(
        `/savings-account/calculate-for-child?${new URLSearchParams({
          initialAmount: request.initialAmount.toString(),
          monthlyAmount: request.monthlyAmount.toString(),
          age: request.age.toString()
        }).toString()}`
      )
  }
}
